import { urlParameterCodes } from '@/constants/urlParams';
import {
  ProductTableProductVariantFragment,
  TileItemRelationsFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { componentByTypename } from '@/ui/utils/componentByTypename';
import { DocShapeId } from '@/utils/shapeIds';
import { ArrayElementType } from '@/integrations/crystallize/types/helpers/ArrayElementType';
import { getPathWithoutFirstSegment } from './get-path-without-first-segment';

export function parseProductVariantIntoLink(
  productVariant:
  | ArrayElementType<TileItemRelationsFragment['productVariants']>
  | ProductTableProductVariantFragment,
  currentPath: string,
  addAccessoryToCart: boolean,
) {
  const path = productVariant.product?.path;
  if (!path) {
    return null;
  }

  const showChooser = componentByTypename(
    productVariant.product?.showChooser?.content,
    'BooleanContent',
  )?.value;

  const isSmartLock = productVariant.product?.shape.identifier === DocShapeId.smartLock;
  const isSubscription = productVariant.product?.shape.identifier === DocShapeId.subscription;
  const isDigitalProduct = productVariant.product?.shape.identifier === DocShapeId.digitalProduct;

  // In the first case open the chooser, in the second case go the PDP and add to cart
  let href;
  switch (true) {
    case isDigitalProduct:
    case isSubscription:
      href = `${path}?${urlParameterCodes.productDetail.serviceId}=true&${urlParameterCodes.productDetail.sku}=${productVariant.sku}`;
      break;
    case showChooser:
    case isSmartLock:
      href = `${path}?${urlParameterCodes.productDetail.chooserOpen}=true&${urlParameterCodes.productDetail.sku}=${productVariant.sku}`;
      break;
    default:
      if (addAccessoryToCart) {
        href = `${path}?${urlParameterCodes.productDetail.chooserOpen}=true&${urlParameterCodes.productDetail.sku}=${productVariant.sku}`;
      } else {
        href = path;
      }
  }

  // disable scroll on navigation, if navigating to the same page - just ading url params and overlay is being open
  const scroll = getPathWithoutFirstSegment(path) !== getPathWithoutFirstSegment(currentPath);

  return {
    href,
    scroll,
  };
}
